<template>
    <span class="flow-margin-left flow-badge w3-round-medium font-weight-bold flow-user-role" v-bind:class="roleLwr">
        {{ $t(roleLwr) }}
    </span>
</template>

<script>
    export default {
        name: "UserRole",
        props: {
            role: {
                type: String,
                default: ''
            }
        },
        computed: {
            roleLwr() {
                return this.role.toLowerCase();
            }
        }
    }
</script>